/** Hook for the Skills read API — M1 Phase C browse surface. */
import { useQuery } from "@tanstack/react-query";
import { useApi, type ApiError } from "@/lib/api";
import type { Skill } from "@/lib/types";

export function useSkills() {
  const apiCall = useApi();
  return useQuery<Skill[], ApiError>({
    queryKey: ["skills"],
    queryFn: ({ signal }) => apiCall<Skill[]>("/api/skills", { signal }),
  });
}
